module.exports = __webpack_public_path__ + "144eb862e9d7d96df8ecfac95542f57e.png";